"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var _nanoPubsub = _interopRequireDefault(require("nano-pubsub"));

var _RouterContext = require("../RouterContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class RouterProvider extends _react.default.Component {
  constructor(props) {
    var _this;

    super(props);
    _this = this;

    _defineProperty(this, "__internalRouter", void 0);

    _defineProperty(this, "_state", void 0);

    _defineProperty(this, "navigateUrl", function (url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var onNavigate = _this.props.onNavigate;
      onNavigate(url, options);
    });

    _defineProperty(this, "navigateState", function (nextState) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _this.navigateUrl(_this.resolvePathFromState(nextState), options);
    });

    _defineProperty(this, "getState", () => this._state);

    _defineProperty(this, "resolvePathFromState", state => {
      return this.props.router.encode(state);
    });

    _defineProperty(this, "navigateIntent", function (intentName, params) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _this.navigateUrl(_this.resolveIntentLink(intentName, params), options);
    });

    _defineProperty(this, "resolveIntentLink", (intentName, parameters) => {
      var _ref = Array.isArray(parameters) ? parameters : [parameters],
          _ref2 = _slicedToArray(_ref, 2),
          params = _ref2[0],
          payload = _ref2[1];

      return this.props.router.encode({
        intent: intentName,
        params,
        payload
      });
    });

    this._state = props.state;
    this.__internalRouter = {
      resolvePathFromState: this.resolvePathFromState,
      resolveIntentLink: this.resolveIntentLink,
      navigateUrl: this.navigateUrl,
      navigate: this.navigateState,
      navigateIntent: this.navigateIntent,
      getState: this.getState,
      channel: (0, _nanoPubsub.default)()
    };
  }

  getChildContext() {
    return {
      __internalRouter: this.__internalRouter
    };
  }

  componentDidUpdate(prevProps) {
    var currentState = this.props.state;
    var prevState = prevProps.state;

    if (!(0, _isEqual2.default)(currentState, prevState)) {
      this._state = currentState;
      setTimeout(() => {
        (0, _reactDom.unstable_batchedUpdates)(() => {
          this.__internalRouter.channel.publish(currentState);
        });
      }, 0);
    }
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_RouterContext.RouterContext.Provider, {
      value: this.__internalRouter
    }, this.props.children);
  }

}

exports.default = RouterProvider;

_defineProperty(RouterProvider, "childContextTypes", {
  __internalRouter: _propTypes.default.object
});